import {WheelOfJbLogoMrgreenBox} from "./wheel-of-jb-logo.mrgreen.box";

export const WheelOfJbLogoMrgreenCisBox = WheelOfJbLogoMrgreenBox;